<template>
  <div class="flex flex-row gap-md">
    <Dot v-for="id of total"  :selected="selected >= id" :color :size/>
  </div>
</template>
<script setup lang="ts">
import Dot from '../../atoms/dot/dot.vue';
import { type TypeSize, Color, type TypeColor } from '../../interfaces'
export interface PropsDots {
  total?: number
  selected?: number
  size?: TypeSize,
  color?: TypeColor

}
 withDefaults(defineProps<PropsDots>(), {
  total: 3,
  selected: 0,
  color: Color.white
})
</script>
